/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * ITKSECErrorcodes enum values.
 */
export enum ITKSEC_ITKSECErrorCodes {
    RoleAssignedToUser = 300010,
}
